import * as React from "react";

function HeroDescription() {
  return (
    <p className="mb-8 text-xl leading-relaxed text-white max-w-[900px] max-md:text-lg max-sm:text-base">
      Want to see how it actually works? Take a closer look at our
      interface, our upcoming modules, and the technology powering the next
      generation of SMMEs.
    </p>
  );
}

export default HeroDescription;
